import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryLegend,
  VictoryTheme,
  VictoryTooltip,
  VictoryGroup,
  VictoryZoomContainer,
} from 'victory';

const GroupedBar = ({
  filteredData,
  chartMeta,
}) => {
  const chartData = chartMeta.composeChartData(filteredData);
  const tickCount = (chartData[0] || []).length + 1;
  const maxima = Math.max(...chartData.reduce((acc, item) => item.map((d, i) => Math.max(acc[i] || 0, d.y)), [])) || 100;
  return (
    <VictoryChart
      height={350}
      width={650}
      padding={{
        left: 70, right: 50, bottom: 30, top: 50,
      }}
      theme={VictoryTheme.material}
      domain={{
        y: chartMeta.domain || [0, maxima],
      }}
      containerComponent={(
        <VictoryZoomContainer
          zoomDomain={{
            x: [0, Math.min(tickCount, 10)],
            y: chartMeta.domain || [0, maxima],
          }}
          allowPan={tickCount > 10}
          allowZoom={false}
        />
      )}
    >
      <VictoryLegend
        x={48}
        orientation="horizontal"
        gutter={10}
        data={_.map(chartMeta.fields, (field) => ({
          name: field.name,
          symbol: { fill: field.color, type: field.type },
        }))}
      />
      <VictoryAxis
        dependentAxis
        tickFormat={chartMeta.yTickFormat}
      />
      <VictoryGroup
        offset={15}
        style={{ data: { width: 12 } }}
        colorScale={_.map(chartMeta.fields, 'color')}
      >
        {chartData.map((rowData, i) => (
          <VictoryBar
            labelComponent={<VictoryTooltip text={(d) => chartMeta.yTickFormat(Number.parseFloat(d.y).toFixed(2))} />}
            key={i} // eslint-disable-line
            data={rowData}
          />
        ))}
      </VictoryGroup>
      <VictoryAxis
        tickValues={chartMeta.xTickValues(filteredData).map((v, i) => `${i}-${v}`)}
        tickFormat={(t) => t.replace(/(\d)+-/, '')}
        style={{
          grid: { display: 'none' },
        }}
      />
    </VictoryChart>
  );
};

GroupedBar.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  filteredData: PropTypes.arrayOf(PropTypes.object),
  chartMeta: PropTypes.objectOf(PropTypes.shape),
};

export default GroupedBar;
